var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gapp-error"},[_c('h2',{staticClass:"gapp_post__module-title"},[_vm._v(_vm._s(_vm.errorMsg)+".")]),_c('p',[_vm._v("We encountered an error while fetching related posts.")])])}
var staticRenderFns = []

export { render, staticRenderFns }